import { render, staticRenderFns } from "./PurchaseSuppliesProducts.vue?vue&type=template&id=14289571&scoped=true&"
import script from "./PurchaseSuppliesProducts.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuppliesProducts.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSuppliesProducts.vue?vue&type=style&index=0&id=14289571&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14289571",
  null
  
)

export default component.exports